/* global angular */

require('../steps-header/steps-header.component.js')
require('../steps-form-wrapper/steps-form-wrapper.component.js')
require('../../../../service/is-uploading.dataservice.js')

angular.module('uniformCmp')
  .component('steps', {
    template: require('./steps.component.tpl.html'),
    controller: StepsCtrl,
    controllerAs: 'vm',
    bindings: {
      formFields: '<',
      buttonName: '<',
      disabledButton: '<',
      showSpinner: '<',
      values: '=',
      onChange: '&',
      onSubmit: '&',
      processPromise: '<',
      fileContents: '<',
      setFormToPristine: '&'
    }
  })

StepsCtrl.$inject = ['$timeout', 'isUploadingDataservice']

function StepsCtrl ($timeout, isUploadingDataservice) {
  var vm = this

  vm.$onInit = function () {
    vm.currentStep = 0
    vm.currentStepId = 0
    vm.deltaStep = 0
    vm.showSpinner = false
    vm.attachmentNames = {}
    vm.nextStep = nextStep
    vm.previousStep = previousStep
    vm.submit = submit
    vm.isStepFirst = isStepFirst
    vm.isStepLast = isStepLast
    vm.getStepId = getStepId
    vm.getStep = getStep
    vm.getSpinner = getSpinner
    vm.stepBack = false
    vm.isUploadingDataservice = isUploadingDataservice
    vm.resetStepValidity = resetStepValidity
    vm.groups = vm.formFields.filter(groupOnly)
    vm.steps = vm.groups.map(function (step) {
      return step.id
    })
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.processPromise && changesObj.processPromise.currentValue) {
      vm.processPromise.then(function (result) {
        vm.currentStepId = vm.getStepId()
        var nextStateIndex = vm.steps.indexOf(vm.currentStepId) + vm.deltaStep
        if (nextStateIndex < vm.steps.length) {
          vm.currentStepId = vm.steps[nextStateIndex]
          vm.currentStep = nextStateIndex
        }
        if (nextStateIndex >= 0) {
          vm.currentStepId = vm.steps[nextStateIndex]
          vm.currentStep = nextStateIndex
        }
      }).catch(function () {
        if (vm.stepBack) {
          vm.currentStepId = vm.getStepId()
          var nextStateIndex = vm.steps.indexOf(vm.currentStepId) + vm.deltaStep
          if (nextStateIndex < vm.steps.length) {
            vm.currentStepId = vm.steps[nextStateIndex]
            vm.currentStep = nextStateIndex
          }
          if (nextStateIndex >= 0) {
            vm.currentStepId = vm.steps[nextStateIndex]
            vm.currentStep = nextStateIndex
          }
        }
      }).finally(function () {
        vm.disabledButton = false
        vm.showSpinner = false
      })
    }
  }

  function resetStepValidity () {
    vm.setFormToPristine()
  }

  function groupOnly (field) {
    return field.fieldType === 'Group'
  }

  function getStepId () {
    return vm.steps[vm.getStep()]
  }

  function getStep () {
    return vm.currentStep
  }

  function previousStep () {
    vm.stepBack = true
    vm.deltaStep = -1
    vm.disabledButton = true
    vm.showSpinner = true
    vm.arrayItems = vm.formFields[vm.currentStep].fields.map(function (item) {
      if (item.fields) {
        vm.innerItems = item.fields.map(function (innerField) {
          return innerField.id
        })
        return item.id
      } else {
        return item.id
      }
    })
    vm.onChange({ arrayItems: vm.arrayItems.concat(vm.innerItems) })
  }

  function nextStep () {
    vm.stepBack = false
    vm.deltaStep = 1
    vm.disabledButton = true
    vm.showSpinner = true
    vm.arrayItems = vm.formFields[vm.currentStep].fields.map(function (item) {
      if (item.fields) {
        vm.innerItems = item.fields.map(function (innerField) {
          return innerField.id
        })
        return item.id
      } else {
        return item.id
      }
    })
    vm.onChange({ arrayItems: vm.arrayItems.concat(vm.innerItems) })
  }

  function isStepFirst () {
    return vm.steps[0] === vm.getStepId()
  }

  function isStepLast () {
    var states = vm.steps
    return states[states.length - 1] === vm.getStepId()
  }

  function submit () {
    vm.deltaStep = 0
    vm.disabledButton = true
    vm.showSpinner = true
    vm.arrayItems = vm.formFields[vm.currentStep].fields.map(function (item) {
      return item.id
    })
    vm.onSubmit({ arrayItems: vm.arrayItems })
  }

  function getSpinner () {
    vm.showSpinner = true
    vm.disabledButton = true
    $timeout(function () {
      vm.showSpinner = false
      vm.disabledButton = false
    }, 1000)
  }
}
